module.exports = __webpack_public_path__ + "media/images/lp/1/support-ashinaga1-sp-c1ac43f92089c1df805b765a130860b7.png";